<template>
  <div class="avance-vista">
    <div class="header-flex">
      <div>
        <h1>Reporte de avance del proceso</h1>
        <p class="subtitulo">Ejecución #{{ idEjecucion }}</p>
      </div>
      <div class="botones-header">
        <button class="btn salir" @click="$router.push({ name: 'ProcesoAutoevaluacionUsuario' })">Volver</button>
        <button class="btn dashboard" @click="$router.push({ name: 'Dashboard' })">Ir al Dashboard</button>
      </div>
    </div>
    <div class="divider"></div>

    <AvanceFactorPanel :id-ejecucion="idEjecucion" />
  </div>
</template>

<script lang="ts" setup>
/**
 * Reporte de avance de un proceso (tablero F-04).
 *
 * Porcentaje de indicadores calificados y semáforo de evidencias por factor.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { useRoute } from 'vue-router'
import AvanceFactorPanel from '@/components/AvanceFactorPanel.vue'

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)
</script>

<style scoped>
.avance-vista {
  background-color: white;
  padding: 2rem;
  border-radius: var(--radius-lg);
  width: 100%;
  min-height: 100%;
  box-shadow: var(--shadow-md);
  box-sizing: border-box;
  font-family: var(--font-family);
}
@media (max-width: 768px) {
  .avance-vista { padding: 1.2rem; border-radius: 0; box-shadow: none; }
}
.header-flex { display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; }
h1 { font-size: 1.4rem; font-weight: 700; margin: 0; color: var(--text-primary); }
.subtitulo { font-size: 0.85rem; color: #666; margin: 0.25rem 0 0; }
.divider { border: none; border-bottom: 1px solid #e0e0e0; margin: 12px 0 16px; }
.btn { padding: 0.5rem 1rem; font-weight: 600; border-radius: 8px; cursor: pointer; transition: all 0.15s ease; font-family: var(--font-family); font-size: 0.85rem; }
.btn.salir { border: 1px solid #bbb; background: #fff; color: #444; }
.btn.salir:hover { border-color: #0e69a0; color: #0e69a0; background: #f0f6fb; }
.btn.dashboard { border: 1px solid #0e69a0; background: #0e69a0; color: #fff; }
.btn.dashboard:hover { background: #0a5480; border-color: #0a5480; }
.botones-header { display: flex; gap: 0.5rem; }
</style>
